import AnalyticsDashboardAppConfig from './analytics/AnalyticsDashboardAppConfig';
import ProjectDashboardAppConfig from './project/ProjectDashboardAppConfig';

const dashboardsProviderConfigs = [AnalyticsDashboardAppConfig, ProjectDashboardAppConfig];

export default dashboardsProviderConfigs;
